import { Text } from "../../../../packages/ui-kit";
import { BotIcon } from "../../../../packages/icons";
import { DICTIONARY } from "../../dictionary";
import styles from "./chat-operator.module.scss";

type Props = {
  subtitle: string;
};

export const ChatOperator = ({ subtitle }: Props) => (
  <div data-test-id="chat-operator" className={styles.operator}>
    <BotIcon />
    <div data-test-id="chat-operator-info" className={styles.info}>
      <Text
        dataTestId="chat-operator-info-title"
        className={styles.name}
        size="medium"
        weight="medium"
      >
        {DICTIONARY.CHAT_TITLE}
      </Text>
      <Text
        dataTestId="chat-operator-info-subtitle"
        className={styles["service-name"]}
        size="xsmall"
      >
        {subtitle}
      </Text>
    </div>
  </div>
);
